import { Injectable } from '@angular/core';
import * as Chart from 'chart.js';
@Injectable({
  providedIn: 'root'
})
export class AttendanceService {
  public DoughnutChart;
  getAttendance() {
    let x = [70,30];
    this.DoughnutChart = new Chart('doughnutChart',{
      type:'doughnut',
      data:{
        labels:["PRESENT","ABSENT"],
        datasets:[{
          label:"CLASS ATTENDANCE",
          data:x,
          backgroundColor:['#E91E63','#9C27B0'],
          borderWidth:1
        }]
      },
      options:{
        title:{
          text:"CLASS ATTENDANCE",
          display:true
        },
        responsive:true,
        // display:true,
      }
    })
    return this.DoughnutChart;

  }
  constructor() { }
}
